import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Flex, Spinner, VStack, Text } from '@chakra-ui/react'
import { useAuth } from '../contexts/AuthContext'

export default function AuthCallback() {
  const navigate = useNavigate()
  const location = useLocation()
  const { isSignedIn, loading, isAuthEnabled } = useAuth()

  const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/app'

  useEffect(() => {
    if (loading) return

    if (!isAuthEnabled) {
      navigate('/app', { replace: true })
      return
    }

    if (isSignedIn) {
      console.log('AuthCallback: User signed in, redirecting to:', from)
      window.history.replaceState(null, '', window.location.pathname)
      navigate(from, { replace: true })
    } else {
      console.log('AuthCallback: User not signed in, redirecting to login')
      navigate('/login', { replace: true })
    }
  }, [isSignedIn, loading, isAuthEnabled, navigate, from])

  return (
    <Flex h="100vh" w="100vw" align="center" justify="center" bg="background.light">
      <VStack spacing={4}>
        <Spinner size="xl" color="brand.500" thickness="4px" />
        <Text color="text.secondary">Completing sign in...</Text>
      </VStack>
    </Flex>
  )
}
